<template>
  <ChatModal title="Add people" width="520px" @close="$emit('close')">
    <div class="form-group">
      <label class="chat-label d-block mb-1" for="addPeopleToInput">To</label>
      <RecipientPicker
        input-id="addPeopleToInput"
        v-model="to"
        :exclude-ids="excluded.concat(cc.map((u) => u.id))"
      />
    </div>
    <div class="form-group">
      <label class="chat-label d-block mb-1" for="addPeopleCcInput">Cc</label>
      <RecipientPicker
        input-id="addPeopleCcInput"
        v-model="cc"
        :exclude-ids="excluded.concat(to.map((u) => u.id))"
      />
    </div>
    <p class="text-muted small">They will see the earlier messages in this conversation.</p>
    <div class="d-flex justify-content-end" style="gap: 8px">
      <button type="button" class="btn btn-outline-secondary" @click="$emit('close')">Cancel</button>
      <button type="button" class="btn chat-btn px-4" :disabled="saving || (!to.length && !cc.length)" @click="save">
        <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span> Add
      </button>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from "./ChatModal.vue";
import RecipientPicker from "./RecipientPicker.vue";
import api, { errorMessage } from "../api";

export default {
  name: "AddPeopleModal",
  components: { ChatModal, RecipientPicker },
  props: {
    conversation: { type: Object, required: true },
  },
  data() {
    return { to: [], cc: [], saving: false };
  },
  computed: {
    excluded() {
      return this.conversation.participants.filter((p) => !p.left).map((p) => p.user_id);
    },
  },
  methods: {
    save() {
      this.saving = true;
      api
        .addParticipants(this.conversation.id, { to: this.to.map((u) => u.id), cc: this.cc.map((u) => u.id) })
        .then((conversation) => this.$emit("saved", conversation))
        .catch((error) => this.$toasted.error(errorMessage(error), { position: "top-center", duration: 4000 }))
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
